import Constants from "expo-constants";

export const getExpoEASConstant = (key: string) => {
  return Constants?.expoConfig?.extra?.eas[key];
};
